<div class="main-container">
  <div class="body">
    <div class="title">
      <img src="../../../assets/images/StackedLogo.svg" class="logo" alt="TechInsights" />
    </div>
    <p class="info">{{message}}</p>
    <div class="contact-info">
      <span>
        Please retry, but if the problem persists contact TechInsights support
      </span>
    </div>
  </div>
  <div class="footer">
    <p class="copyright">©TechInsights Inc. {{currentYear}} all rights reserved.</p>
    <div class="links-container">
      <a href="https://library.techinsights.com/sectioned-blog-viewer/f05b514a-c6fc-4f9c-9271-39738a26bc98" class="link">Terms of Service</a>
       |
      <a href="https://library.techinsights.com/sectioned-blog-viewer/8cf247e6-2c3a-4d48-b2cd-de316e0bb0f6" class="link">Privacy Policy</a>
       |
      <a href="https://go.techinsights.com/l/1043171/2023-11-10/3ts89x" class="link">Contact Support</a>
    </div>
  </div>
</div>
